import { post, get, postJson, put } from "../axios4";

// 分页查询推荐问题列表
export const getRecommended = (p) => get(`/ai-recommend-question/page`, p);

// 点赞、踩接口
export const likeAndStep = (p) => post(`/ai-chat-message/open-ai-chat`, p);

// 分页查询消息列表
export const getMessage = (p) => get(`/ai-chat-message/page`, p);

// 开启新对话
export const toNewChat = (p) => post(`/ai/openAiChat`, p);

// 发送消
export const sendMessage = (p) => postJson(`/ai/sendMessage`, p);

// 分页查询消息列表
export const getLastChatType = (p) =>
  get(`/ai-chat-message/get-last-chat-type`, p);
